import { Component, Input } from '@angular/core';
import { ImpactOverlayRef } from '@impactdk/ngx-overlay';

import { closeLightIcon } from '../../icons';

export enum PanelSizes {
    SMALL = 'panel-size__small',
    MEDIUM = 'panel-size__medium',
    LARGE = 'panel-size__large'
}

@Component({
    selector: 'app-panel',
    template: `
        <section class="panel {{panelSize}}">
            <section class="panel__header">
                <div>
                    <h3 class="component-header--small theme-text" *ngIf="smallHeaderText">{{ smallHeaderText }}</h3>
                    <h4 class="no-margin">{{ headerText }}</h4>
                </div>
                <div class="panel__header-button">
                    <app-button [buttonClass]="'button button--round-with-icon'" (click)="this.dialogRef.close()">
                        <i aria-hidden="true" class="button__icon">${closeLightIcon}</i>
                    </app-button>
                </div>
            </section>
            <section class="panel__content">
                <ng-content></ng-content>
            </section>
        </section>
    `,
})
export class PanelComponent {
    @Input() headerText?: string;
    @Input() smallHeaderText?: string;
    @Input() panelSize?: string = PanelSizes.SMALL;

    constructor(public readonly dialogRef: ImpactOverlayRef) {}
}
